/** A state-document section, with its `[upload_id]` citations made checkable in one click.
 *
 * This verifies nothing; it puts a claim and its source one click apart so a human
 * skimming can check the one that looks wrong. The citation machinery is shared
 * with the conversation transcript (``useCitations``) so the two surfaces behave
 * identically, and everything below the citation is the Files tab's own
 * ``SourceTextModal`` - there is one document viewer to maintain.
 *
 * The citations are passed IN rather than resolved here: a state document has a
 * dozen sections, and a hook per section is a lookup per section (principle 8).
 * The tab holds one over all of them.
 */
import { Markdown } from "./Markdown";
import type { Citations } from "./useCitations";

export const CitedBody = ({
  body,
  citations,
  className,
}: {
  body: string;
  citations: Citations;
  // The caller owns the prose styling (this renders inside their section card);
  // only the citation affordance itself is styled here.
  className?: string;
}): JSX.Element => (
  <div className={className}>
    <Markdown components={citations.components}>{citations.transform(body)}</Markdown>
  </div>
);
